import { defineStore } from 'pinia';
import ViajesGrupoApiService from '../services/api/ViajesGrupoApiService';
export const viajesGrupos = defineStore('viajesGrupos', {
  state: () => ({
    viajes: null,
    viajeSeleccionado: null,
  }),
  getters: {
    getViajes(state) {
      return state.viajes || [];
    },
    getViajeSeleccionado(state) {
      return state.viajeSeleccionado;
    },
  },
  actions: {
    async fetchResumenViajes() {
      if (this.viajes == null) {
        this.viajes = await ViajesGrupoApiService.getViajes();
      }
      return this.viajes;
    },
    setViajes(viajes) {
      this.viajes = viajes;
    },
    async fetchViajeSeleccionado(viajeId, codigoViaje = null, codigoPrevisualizacion = null, force = false) {
      if (force || this.viajeSeleccionado === null || this.viajeSeleccionado.id !== viajeId) {
        this.viajeSeleccionado = await ViajesGrupoApiService.getViaje(viajeId, codigoViaje, codigoPrevisualizacion);
      }
      return this.viajeSeleccionado;
    },
  },
});
